import { Component, Input, OnInit } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { of, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-box',
    templateUrl: './box.component.html',
    styleUrls: ['./box.component.scss'],
})
export class BoxComponent implements OnInit {
    public name: string = 'User Name';
    @Input('name') set n(name) {
        this.name = name;
    }
    '';

    private $destroy: Subject<any> = new Subject<any>();
    menuItems: NbMenuItem[];

    @Input('menu') set m(items) {
        if (this.menuItems?.length) return;

        this.menuItems = items;
    }

    constructor(private nbMenuService: NbMenuService) {}

    ngOnInit(): void {
        // //console.log(this.menuItems);
    }

    ngOnDestroy() {
        this.$destroy.next();
        this.$destroy.complete();
    }
}
